
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { canvasProperties } from "../config";
import { MixBlend, Spine } from "@esotericsoftware/spine-pixi-v8";
import { brightnessFilter, brightnessFilter2, dullFilter, dullFilter2, font_main, glowFilter, HandleOrientation } from "./global";
import { gsap } from "gsap/gsap-core";
import { LogoAnim } from "../app";
import { generateBonusRow, currencySymbol } from "./server";
import { SoundManager } from "./sounds";
import { EnumEventBus, EventBus } from "../EventBus";
let visibleElements: PIXI.ContainerChild[] = []
type contType = PIXI.Container & {
	animName?: string;
	boxBg?: Spine;
	boxType?: string;
	shatterAnim?: Spine;
	box_Text?: PIXI.Text;
	row_i?: number;
	backUp_Y?: number;
	laser_burst?: Spine;
	win?: number
}
export class Bonus extends PIXI.Container {
	// boxData!:(string|number)[][];
	bonusWin!: number;
	bonusBg!: PIXI.Sprite;
	// transition!: Spine;
	roboAnim!: Spine;
	blocksContainer!: PIXI.Container;
	blockAndFrameContainer!: PIXI.Container;
	BlocksColContArr: contType[] = [];
	Ind_BlocksArr: contType[][] = [];
	blocksOrder = [7, 5, 3, 2, 1];
	boxTypes = Array(5).fill(null).map((_, i) => `Tier${i + 1}`);
	intialBoxYpos: number = 0
	app!: PIXI.Application;
	beam_anim!: Spine;
	roboAnimNames = [1, 2, 3, 4, 5];
	bonusContainer!: PIXI.Container;
	private _beamConstraint?: any;          // PathConstraint named "beam"
	private _boneMain?: any;                // "main"
	private _boneStart?: any;               // "starting point"
	private _boneTarget?: any;              // "target"     
	private bonusInfotext!: PIXI.Text;
	BlocksBg!: PIXI.Sprite;
	rowData!: (string | number)[];
	/*frameTextures = [
		"bonus_reel_bg_mud",
		"bonus_reel_bg_wood",
		"bonus_reel_bg_brick",
		"bonus_reel_bg_stone",
		"bonus_reel_bg_gold"
	];*/
	constructor() {
		super();
		this.createBonusPage();
		this.visible = false;
		EventBus.on(EnumEventBus.showBonus, () => this.showBonus());
		EventBus.on(EnumEventBus.logoAnimAllsuper, () => !LogoAnim.allsuper ? this.visible = false : "");
	}
	createBonusPage() {
		this.bonusContainer = new PIXI.Container();
		//this.bonusContainer.visible = false;
		this.addChild(this.bonusContainer);
		this.createBlocksContainer();
		this.createInfoText()
		this.createRoboAnim();
		HandleOrientation(this.PortraitAdjustFun.bind(this), this.landScapeAdjustFun.bind(this))

	}
	createRoboAnim() {
		this.beam_anim = Spine.from({ skeleton: "beam_anim_anim_json", atlas: "beam_anim_anim_atlas" });
		this.beam_anim.x = canvasProperties.width / 2;
		this.beam_anim.y = canvasProperties.height / 2;
		this.bonusContainer.addChild(this.beam_anim);
		this.beam_anim.visible = false;
		this.beam_anim.state.setAnimation(0, "animation1", false);
		this.beam_anim.state.timeScale = 0;

		this.roboAnim = Spine.from({ skeleton: "robo_anim_json", atlas: "robo_anim_atlas", scale: 0.9 });
		this.roboAnim.x = canvasProperties.width / 2;
		this.roboAnim.y = canvasProperties.height / 2;
		this.bonusContainer.addChild(this.roboAnim);
		this.roboAnim.visible = false;
		this.roboAnim.state.setAnimation(0, "idle_1", true);
		this.initBeamRig()
	}
	createInfoText() {
		this.bonusInfotext = new PIXI.Text({
			text: "Tap a block to fire. Reveal cash—or a power up to the next tier.",
			style: {
				fill: 0xffffff,
				fontSize: 30,
				fontWeight: "900",
				align: "center",
				dropShadow: {
					alpha: 1,
					angle: 1,
					blur: 2,
					color: "0x111111",
					distance: 2,
				},
				stroke: {
					color: "black",
					width: 5,
					join: "round",
				}
			}
		})
		this.bonusInfotext.anchor.set(0.5);
		this.bonusInfotext.position.set(canvasProperties.width / 2, canvasProperties.height / 1.1 - 5);
		this.bonusContainer.addChild(this.bonusInfotext);
	}
	private initBeamRig() {
		const sk = this.beam_anim.skeleton;
		this._beamConstraint = sk.findPathConstraint("beam");
		this._boneMain = sk.findBone("main");
		this._boneStart = sk.findBone("starting point");
		this._boneTarget = sk.findBone("target");

		if (!this._beamConstraint || !this._boneMain || !this._boneStart || !this._boneTarget) {
			console.warn("Beam rig: missing path constraint 'beam' or bones 'main'/'starting point'/'target'.");
		}
	}
	private setBoneToGlobal(bone: any, global: PIXI.Point) {
		// 1) Convert global → beam skeleton local
		const pInBeam = this.beam_anim.toLocal(global);

		// 2) Convert to the local space of the bone's *parent*
		const parent = bone.parent; // spine.Bone
		const local = parent.worldToLocal(pInBeam); // <- returns {x,y}

		// 3) Set the bone's local coords
		bone.x = local.x;
		bone.y = local.y;
	}
	private fireBeamTo(box: contType) {
		// 1) World points
		const muzzleGlobal = (() => {
			const muzzleBone = this.roboAnim.skeleton.findBone?.("rhctrl");
			if (muzzleBone) {
				const p = new PIXI.Point(muzzleBone.worldX + 10, muzzleBone.worldY - 10);
				return this.roboAnim.toGlobal(p);
			}
			const r = this.roboAnim.getBounds();
			return new PIXI.Point(r.left, r.y + r.height * 0.5);
		})();
		const targetGlobal = box.getGlobalPosition();

		// 2) Make beam visible and restart any flash/FX animation you’re using
		this.beam_anim.visible = true;
		this.beam_anim.state.setAnimation(0, "animation1", false);
		SoundManager.Robot_Shoot_sound1.play();

		// 3) Place path endpoints (controller bones)
		if (this._boneStart && this._boneTarget) {
			this.setBoneToGlobal(this._boneStart, muzzleGlobal);
			this.setBoneToGlobal(this._boneTarget, targetGlobal);
		}

		// 4) Push transforms before animating the path value
		this.beam_anim.update(0); // evaluates constraints/poses without advancing time

		// 5) Drive along the path by tweening the path constraint's "position"
		if (this._beamConstraint) {
			// If your PathConstraint’s Position mode is Percent, 0→1 is ideal.
			// Your JSON shows values like 1→2.1962 in animation2, so we’ll normalize to 0→1:
			// Most reliable approach: just set 0 at start, 1 at end and let the runtime map it.
			this._beamConstraint.position = 0;

			gsap.to(this._beamConstraint, {
				position: 1,
				duration: 0.35,
				ease: "power2.out",
				onUpdate: () => {
					this.beam_anim.update(0); // keep constraint evaluated each frame
				},
				onComplete: () => {
					this.beam_anim.state.setAnimation(0, "animation2", false);
					// Impact VFX and resolve
					if (box.laser_burst) {
						box.laser_burst.visible = true;
						box.laser_burst.state.setAnimation(0, "animation", false);
						box.laser_burst.state.timeScale = 1;
					}
					setTimeout(() => {
						if (box.shatterAnim) {
							box.shatterAnim.visible = true;
							SoundManager.Box_Shatter.play();
							if (!box.animName) { return };
							const animToPlay = box.animName;

							if (box.shatterAnim.state.data.skeletonData.findAnimation(animToPlay)) {
								box.shatterAnim.state.setAnimation(0, animToPlay, false);
								this.Ind_BlocksArr[box.row_i!].forEach(el => {
									el.boxBg!.visible = true;
								});
							} else {
								console.error(`Animation is not found: ${animToPlay}. Check the name in json file`);
							}

							this.checkBonWin(box);
						}
					}, 300);
				}
			});
		}
	}
	animateRobo() {
		if (window.matchMedia("(orientation:portrait)").matches) {
			gsap.fromTo(this.roboAnim,

				{ x: canvasProperties.width, y: canvasProperties.height + this.roboAnim.height / 2, duration: 2, delay: 1 },
				{ x: 839, y: 299 });

		} else {
			gsap.fromTo(this.roboAnim,
				{ x: canvasProperties.width / 2, y: canvasProperties.height + this.roboAnim.height / 2, duration: 2, delay: 1 },
				{ x: canvasProperties.width - this.roboAnim.width / 2, y: canvasProperties.height / 2 + 100 })
		}

	};
	createBlocksContainer() {
		this.blockAndFrameContainer = new PIXI.Container();
		this.blocksContainer = new PIXI.Container();
		this.bonusContainer.addChild(this.blockAndFrameContainer);
		const BlocksBg = new PIXI.Sprite(Assets.get("bonus_reel_bg_wood"));
		BlocksBg.anchor.set(0.5)
		this.blockAndFrameContainer.addChild(BlocksBg);
		this.BlocksBg = BlocksBg;
		const frameMask = new PIXI.Graphics()
			.rect(0, 0, BlocksBg.width - 80, BlocksBg.height - 85).fill(0x000000)
		frameMask.alpha = 0.5;
		frameMask.pivot.set(frameMask.x + frameMask.width / 2, frameMask.y + frameMask.height / 2)
		this.blockAndFrameContainer.addChild(frameMask);
		this.blocksContainer.mask = frameMask;
		this.blockAndFrameContainer.addChild(this.blocksContainer);
		let singleBoxWidth = 0;

		for (let i = 0; i < this.blocksOrder.length; i++) {
			const container: contType = new PIXI.Container();
			const blocksArr: PIXI.Container[] = []
			for (let j = 0; j < this.blocksOrder[i]; j++) {
				const block = this.create_a_block(i);
				singleBoxWidth = block.width + 10;

				block.x = j * (singleBoxWidth);
				blocksArr.push(block);
				container.addChild(block);
			}
			const b = container.getLocalBounds();
			container.pivot.set(b.x + b.width / 2, b.y + b.height / 2);
			this.Ind_BlocksArr.push(blocksArr);
			container.y = BlocksBg.height / 3;
			this.intialBoxYpos = BlocksBg.height / 3;
			container.visible = false;
			container.backUp_Y = -i * (container.height + 10) + BlocksBg.height / 3.75 + 2;
			this.BlocksColContArr.push(container);
			this.blocksContainer.addChild(container);
		};
		this.blocksContainer.children.reverse();
		this.blockAndFrameContainer.x = canvasProperties.width / 2;
		this.blockAndFrameContainer.y = canvasProperties.height / 2;
	}
	animateBoxes(arr: contType[]) {
		const copyArr = arr.slice()
		copyArr[0].visible = true;
		const DestY = copyArr[0].backUp_Y;
		gsap.to(copyArr, { y: DestY, duration: 0.75, ease: "elastic.out(1,0.5)" });
		gsap.delayedCall(0.35, () => {
			copyArr.shift();
			if (copyArr.length > 0) this.animateBoxes(copyArr);
			else {
				this.Ind_BlocksArr.forEach((boxes, i) => {
					boxes.forEach((box, i) => {
						box.interactive = true;
					});
				});
				this.updateBoxHighlights(0);
			}
		}, [copyArr])

	}
	create_a_block(index: number): contType {
		const box: contType = new PIXI.Container();
		box.scale.set(0.8);

		//const box_bg = Spine.from({ skeleton: "powerup_anim_json", atlas: "powerup_anim_atlas" });
		const box_bg = Spine.from({ skeleton: "power_up_or_cash_anim_json", atlas: "power_up_or_cash_anim_atlas" });
		box.boxBg = box_bg;
		box.boxBg.y = 48;
		box.boxBg.visible = false

		const box_Text = new PIXI.Text({ text: "1.00" });
		box_Text.style = {
			fontFamily: font_main,
			align: "center",
			fill: "white",
			fontSize: 30,
			//fontWeight: 'lighter',
			/*dropShadow: {
				alpha: 0.8,
				angle: 1,
				blur: 4,
				color: '0x111111',
				distance: 2,
			},*/
			/*stroke: {
				color: "black",
				width: 2,
				join: "round"
			},*/
			letterSpacing: -2 //2
		};
		box_Text.alpha = .7;
		box_Text.anchor.set(0.5);
		box.box_Text = box_Text;
		box.row_i = index;

		const shatterAnim = Spine.from({ skeleton: "bonus_game_blocks_anim_json", atlas: "bonus_game_blocks_anim_atlas" });

		const tierName = this.boxTypes[index];
		const staticAnimName = `static${tierName}`;
		const revealAnimName = `reveal${tierName}`;

		shatterAnim.state.setAnimation(0, staticAnimName, false);
		shatterAnim.state.addListener({
			complete: (entry) => {
				if (entry.animation?.name.startsWith("reveal")) {
					shatterAnim.visible = false;
				}
			}
		});


		box.shatterAnim = shatterAnim;
		box.animName = revealAnimName;
		// box.boxType = "power-up";
		const laser_burst = Spine.from({ skeleton: "laser_burst_anim_json", atlas: "laser_burst_anim_atlas" });
		laser_burst.state.setAnimation(0, "animation", false);
		laser_burst.state.timeScale = 0;
		laser_burst.visible = false;
		laser_burst.state.addListener({
			complete: () => {
				laser_burst.visible = true;
			}
		})
		box.laser_burst = laser_burst;
		box.addChild(box_bg, box_Text, shatterAnim, laser_burst);
		// animation;




		box.interactive = true;
		box.cursor = "pointer";
		box.on("pointerover", () => box.filters = [brightnessFilter])
		box.on("pointerout", () => box.filters = [])
		box.on("pointertap", () => {
			this.sendClickRequest(box.row_i!)
			box.boxBg!.filters = [glowFilter]
			this.Shoot_a_box(box)
		})
		return box;
	};
	Shoot_a_box(box: contType) {
		gsap.killTweensOf(brightnessFilter2);
		brightnessFilter2.brightness(1, false);
		box.parent!.filters = [];

		// Robot anims first
		// this.roboAnim.state.applyMixingFrom(this.robo,this.roboAnim.skeleton,MixBlend)
		this.roboAnim.state.setAnimation(0, "shoot_" + this.roboAnimNames[box.row_i!], false);
		this.roboAnim.state.addAnimation(0, "idle_" + this.roboAnimNames[box.row_i!], true);

		// Row becomes dull/non-interactive while firing
		this.Ind_BlocksArr[box.row_i!].forEach(el => {
			el.interactive = false;
			el.filters = [dullFilter];
		});
		box.filters = [];

		// Make beam visible and (optionally) play NON-path VFX on a different track
		this.beam_anim.visible = true;
		this.beam_anim.state.timeScale = 2.0; // keep normal; path is driven by code
		this.beam_anim.state.setEmptyAnimations();// default mix = 0
		// clear track 1 if used previously
		// Optional: play a small flash on Track 1 that DOES NOT key the path
		// this.beam_anim.state.setAnimation(1, "muzzle_flash_fx", false);

		// IMPORTANT: Do NOT move beam_anim.x/y after fireBeamTo sets bones
		// If you need a base placement, set it ONCE at init or BEFORE fireBeamTo and keep it fixed.
		// this.beam_anim.x = this.roboAnim.x - this.roboAnim.getLocalBounds().width / 2;
		// this.beam_anim.y = this.roboAnim.y;

		// Fire via path constraint tween (handles impact & shatter in its onComplete)
		setTimeout(() => {
			this.fireBeamTo(box);  // << this controls the beam travel and impact; no extra listeners needed
		}, 150);
	}
	sendClickRequest(row: number) {
		// let bonusData = [["power-up",1,4,3,5,4,3],["power-up",1,4,3,5],[30,"power-up",50],["power-up",100],[1000]];
		const rowData = generateBonusRow(row);//bonusData[row]//
		this.updateRow(rowData, row)
	}
	updateBoxHighlights(index: number) {
		this.BlocksColContArr.forEach((boxCont, i) => {
			if (i > index) {
				boxCont.filters = [dullFilter2];
				boxCont.interactiveChildren = false;
			}
			else if (i == index) {
				boxCont.filters = [brightnessFilter2];
				boxCont.interactiveChildren = true;

			}
			else boxCont.filters = []
		})
		// gsap.to(brightnessFilter2,{brightness:1,repeat:-1,yoyo:true}) 
	}
	resetBonus() {
		this.BlocksBg.texture = Assets.get("bonus_game_bg"/**this.frameTextures[0] */)
		this.bonusContainer.visible = true;
		this.BlocksColContArr.forEach((boxCont, i) => {
			boxCont.y = 0;
		})
		this.Ind_BlocksArr.forEach((boxes, j) => {
			boxes.forEach((box) => {
				if (box.boxBg) box.boxBg.visible = false;
				if (box.shatterAnim) {

					const tierName = this.boxTypes[j];
					const staticAnimName = `static${tierName}`;
					box.shatterAnim!.visible = true;
					box.shatterAnim!.state.setAnimation(0, staticAnimName, false);
				}

				box.filters = [];
				if (box.parent) {
					box.parent.filters = [];
				}
			});
		});
	}
	updateRow(rowData: (string | number)[], row: number) {
		this.Ind_BlocksArr[row].forEach((box, i) => {
			if (String(rowData[i]) == "power-up") {
				box.box_Text!.text = ""
				box.boxBg!.state.setAnimation(0, "win_idle", true)
				box.boxBg!.scale.set(.9);
				box.boxBg!.y = 48 * .9;
				box.boxType = "power-up";
			} else {
				box.box_Text!.text = currencySymbol + (Number(rowData[i]).toFixed(2));
				box.box_Text!.scale.set(1);
				if (box.box_Text!.width > 100) {
					box.box_Text?.scale.set(100 / box.box_Text.width);
				}
				box.boxType = "win";
				box.win = Number(rowData[i]);
				if (box.boxBg) {
					box.boxBg.state.setAnimation(0, "static", false);
				}
			}
			box.interactive = false;
		});
	}
	checkBonWin(box: contType) {
		const hideShatterRow = () => this.Ind_BlocksArr[box.row_i!]
			.forEach(element => element.shatterAnim!.visible = false);

		if (box.row_i! >= this.BlocksColContArr.length - 1) {
			SoundManager.Bonus_Celebration.play();
			setTimeout(() => {
				hideShatterRow();
				this.bonusWin = box.win!;
				setTimeout(() => {
					this.showBonusWin();
				}, 500);
			}, 500);
		} else if ((box.row_i! >= this.BlocksColContArr.length - 2) && box.boxType == "power-up") {

			this.roboAnim.state.setAnimation(0, "win_" + this.roboAnimNames[box.row_i!], false);
			this.roboAnim.state.addAnimation(0, "idle_" + this.roboAnimNames[box.row_i! + 1], true);
			this.BlocksColContArr[this.BlocksColContArr.length - 1].children[0].interactive = false;

			setTimeout(() => {
				hideShatterRow();
				this.sendClickRequest(box.row_i! + 1)
				//this.BlocksBg.texture = Assets.get(this.frameTextures[box.row_i! + 1])
				this.Shoot_a_box(this.BlocksColContArr[this.BlocksColContArr.length - 1].children[0])
			}, 500);
		}
		else if (box.boxType == "power-up") {
			SoundManager.Robot_Powerup.play();
			this.roboAnim.state.setAnimation(0, "win_" + this.roboAnimNames[box.row_i!], false);
			this.roboAnim.state.addAnimation(0, "idle_" + this.roboAnimNames[box.row_i! + 1], true);

			setTimeout(() => {
				//this.BlocksBg.texture = Assets.get(this.frameTextures[box.row_i! + 1])

				this.highlightBoxes();
				this.updateBoxHighlights(box.row_i! + 1);
				hideShatterRow();
			}, 500);
		} else {
			SoundManager.Bonus_Win_Robot_reveals_win.play();

			setTimeout(() => {
				this.Ind_BlocksArr[box.row_i!].forEach((element, i) => {
					element.shatterAnim!.visible = false;
				});
				this.bonusWin = box.win!;

				setTimeout(() => {
					this.showBonusWin();
				}, 500);
			}, 500);

		}
	}
	startBonus() {
		this.visible = true;
		this.bonusContainer.visible = false;
		this.blockAndFrameContainer.visible = false;
		EventBus.emit(EnumEventBus.startTransitionAnim1);
	}
	showBonus() {
		visibleElements = [];
		this.app.stage.children.forEach(obj => {
			if (obj.visible) {
				visibleElements.push(obj)
			}
			obj.visible = false;
		})
		this.visible = true
		LogoAnim.visible = true;
		// LogoAnim.scale.set(0.2);
		if (window.matchMedia("(orientation:portrait)").matches) {
			LogoAnim.scale.set(0.15);

		} else {
			LogoAnim.scale.set(0.2);

		}
		this.roboAnim.state.setAnimation(0, "idle_1", true);
		this.bonusBg.texture = Assets.get("Bonuspage_bg");
		SoundManager.Bonus_Enter_Transition.play();
		SoundManager.Bgmusic_Bonus.play()
		SoundManager.Bgmusic_Main.stop();

		EventBus.emit(EnumEventBus.setTranstionAnim2);
		//this.transition.state.setAnimation(0,"animation2",false);
		this.blockAndFrameContainer.visible = true;
		this.resetBonus()
		this.animateBoxes(this.BlocksColContArr)
		this.roboAnim.visible = true;
		this.animateRobo();
		this.highlightBoxes();
	}
	highlightBoxes() {
		const proxy = { b: 1 }; // 1 = normal
		gsap.to(proxy, {
			b: 1.6,
			duration: 0.6,
			ease: "sine.inOut",
			yoyo: true,
			repeat: -1,
			onUpdate() {
				brightnessFilter2.brightness(proxy.b, false); // false = don’t multiply
			}
		});
	}
	showBonusWin() {
		LogoAnim.allsuper = false;
		LogoAnim.PopupStage!.showWinPopup!(this.bonusWin, undefined, () => {
			setTimeout(() => {
				// this.transition.visible = true; 
				SoundManager.Bonus_Exit_Transition.play();
				EventBus.emit(EnumEventBus.startTransitionAnim2);
				// this.transition.state.setAnimation(0,"animation2",false);
				SoundManager.Bgmusic_Bonus.stop()
				SoundManager.Bgmusic_Main.play();
				setTimeout(() => {
					this.endBonus();
					LogoAnim.PopupStage!.closeWinPopup(1);
				}, 500);
			}, 150);
		})
	}
	endBonus() {
		this.bonusBg.texture = Assets.get("bg_game_wide");
		LogoAnim.insideBonus = false;
		visibleElements.forEach(element => {
			element.visible = true
		})

		LogoAnim.scale.set(0.15)
		this.bonusContainer.visible = false;
		brightnessFilter2.brightness(1, false);
		gsap.killTweensOf(brightnessFilter2);
	}
	PortraitAdjustFun() {
		if (this) {
			this.blockAndFrameContainer.scale?.set(0.6)
			this.blockAndFrameContainer.x = 681//canvasProperties.width/2;
			this.blockAndFrameContainer.y = 389//canvasProperties.height/2;   

			gsap.killTweensOf(this.roboAnim)
			this.roboAnim.x = 839;
			this.roboAnim.y = 299;
			this.roboAnim.scale.set(0.65)


			this.bonusInfotext.y = 584
			this.bonusInfotext.style.fontSize = 20;
			this.bonusInfotext.style.wordWrap = true;
			this.bonusInfotext.style.wordWrapWidth = 516.5;
			if (LogoAnim.insideBonus) {
				LogoAnim.scale.set(0.15);
			}
		}
	}
	landScapeAdjustFun() {
		if (this) {
			this.blockAndFrameContainer.scale?.set(1)
			this.blockAndFrameContainer.x = canvasProperties.width / 2;
			this.blockAndFrameContainer.y = canvasProperties.height / 2;

			this.bonusInfotext.style.fontSize = 30;
			this.bonusInfotext.style.wordWrap = false;
			this.bonusInfotext.position.set(canvasProperties.width / 2, canvasProperties.height / 1.1 - 5);
			// x:canvasProperties.width-this.roboAnim.width/2,y:canvasProperties.height/2+100
			gsap.killTweensOf(this.roboAnim)
			this.roboAnim.x = canvasProperties.width - this.roboAnim.width / 2;
			this.roboAnim.y = canvasProperties.height / 2 + 100;
			this.roboAnim.scale.set(1)
			if (LogoAnim.insideBonus) {
				LogoAnim.scale.set(0.2);
			}
		}
	}
}